var map = {
	"./embryo": [
		6849,
		9,
		849
	],
	"./embryo.js": [
		6849,
		9,
		849
	],
	"./embryo.svg": [
		8157,
		1,
		157
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2621;
module.exports = webpackAsyncContext;